








import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { BehaviorEnum } from "@/services/posts/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MediaType, VscFile } from "@/services/files/types";
import ImageSubRenderComponent from "./mediaSubRenderComponents/ImageSubRenderComponent.vue";
import VideoSubRenderComponent from "./mediaSubRenderComponents/VideoSubRenderComponent.vue";

@Component({
    components: {
        ImageSubRenderComponent,
        VideoSubRenderComponent
    }
})
export default class MediaComponent extends Vue {
    @Prop() vsid!: string;
    @Prop() data!: fixedHtmlData[];
    @Prop() active!: number;

    imageDisplayStyles = "";
    mediaType = MediaType;

    get properties(): fixedHtmlData {
        const prop = this.data.filter((x: fixedHtmlData) => x.id === this.vsid)[0];
        // Backward compatibility for the old Image Component Form Data
        if (!prop.selectedMediaType) {
            prop.selectedMediaType = MediaType.Image;
        }
        return prop;
    }

    @Watch("properties", { immediate: true, deep: false })
    onItemChanged(value: any) {
        this.calculateImageDisplayStyles();
    }

    mounted() {
        // set the container size for undefined height and width image component.
        const mediaContainerElement = this.$refs.mediaContainer as HTMLElement;
        mediaContainerElement.style.height = this.properties.position.channelHeight + "px";
        mediaContainerElement.style.width = this.properties.position.channelWidth + "px";
    }

    calculateImageDisplayStyles() {
        this.imageDisplayStyles = "";
        if (this.properties.behavior === BehaviorEnum.adjust) {
            if (this.properties.position.factor && this.properties.position.cropSizeHeight && this.properties.position.cropSizeWidth) {
                const ratio = Math.max(this.properties.position.channelWidth / this.properties.position.imgWidth, this.properties.position.channelHeight / this.properties.position.imgHeight);
                const ratio2 = Math.max((this.properties.position.channelWidth * this.properties.position.factor) / this.properties.position.cropSizeWidth, (this.properties.position.channelHeight * this.properties.position.factor) / this.properties.position.cropSizeHeight);
                this.imageDisplayStyles = `
                    transform: scale(${ratio * ratio2});
                    margin-left: ${-this.properties.position.x * ratio2}px;
                    margin-top: ${-this.properties.position.y * ratio2}px;
                `;
            }
        }

        if (this.properties.behavior === BehaviorEnum.crop) {
            const ratio = Math.max(this.properties.position.channelWidth / this.properties.position.imgWidth, this.properties.position.channelHeight / this.properties.position.imgHeight);
            if (ratio < 1) {
                this.imageDisplayStyles = `transform: scale(${ratio}) translate(-50%, -50%)`;
            }
        }

        if (this.properties.behavior === BehaviorEnum.letterBox) {
            const ratio = Math.min(this.properties.position.channelWidth / this.properties.position.imgWidth, this.properties.position.channelHeight / this.properties.position.imgHeight);
            if (this.properties.position.imgWidth > this.properties.position.channelWidth || this.properties.position.imgHeight > this.properties.position.channelHeight) {
                this.imageDisplayStyles = `
                    width: ${this.properties.position.imgWidth * ratio}px;
                    height: ${this.properties.position.imgHeight * ratio}px;
                `;
            }
        }
    }
}
